import React, { useEffect, useState } from "react";
import Card from "@mui/material/Card";
import Icon from "@mui/material/Icon";
import CircularProgress from "@mui/material/CircularProgress";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import { useNavigate } from "react-router-dom";
import Grid from "@mui/material/Grid";
import CategoryIcon from "@mui/icons-material/Category";
import Party from "./Adv&Exp.Party";
import ExpenseHead from "./Adv&Exp.ExpenseHead";
import Expense from "./Adv&Exp.Expense";
import Advance from "./Adv&Exp.Advance";
import AdvanceSettlement from "./Adv&Exp.AdvanceSettlement";
import AllTypesFeesReport from "./Adv&Exp.AllTypesFeesReport";

function AdvExp() {
  const [loading, setLoading] = useState(true);
  const [activeView, setActiveView] = useState("home");
  const navigate = useNavigate();

  useEffect(() => {
    setLoading(false);
  }, []);

  const handleNavigate = (path) => {
    const token = sessionStorage.getItem("token");
    if (!token) {
      navigate("/authentication/sign-in");
    } else {
      setActiveView(path);
    }
  };

  const handleBack = () => {
    setActiveView("home");
  };

  const renderContent = () => {
    switch (activeView) {
      case "party":
        return (
          <>
            <Party />
          </>
        );
      case "expensehead":
        return (
          <>
            <ExpenseHead />
          </>
        );
      case "expense":
        return (
          <>
            <Expense />
          </>
        );
      case "advance":
        return (
          <>
            <Advance />
          </>
        );
      case "settlement":
        return (
          <>
            <AdvanceSettlement />
          </>
        );
      case "alltypesfeesreport":
        return (
          <>
            <AllTypesFeesReport />
          </>
        );

      default:
        return (
          <Grid container spacing={3}>
            <Grid item xs={12} sm={2} mx={1} mt={2} py={1} px={2}>
              <MDButton
                fullWidth
                color="info"
                variant="gradient"
                size="large"
                sx={{ width: 200, height: "90px", fontSize: "1rem" }}
                startIcon={<CategoryIcon />}
                onClick={() => handleNavigate("party")}
              >
                PARTY MASTER
              </MDButton>
            </Grid>
            <Grid item xs={12} sm={2} mx={1} mt={2} py={1} px={2}>
              <MDButton
                fullWidth
                color="info"
                variant="gradient"
                size="large"
                sx={{ width: 200, height: "90px", fontSize: "1rem" }}
                startIcon={<CategoryIcon />}
                onClick={() => handleNavigate("expensehead")}
              >
                EXPENSE HEAD
              </MDButton>
            </Grid>
            <Grid item xs={12} sm={2} mx={1} mt={2} py={1} px={2}>
              <MDButton
                fullWidth
                color="info"
                variant="gradient"
                size="large"
                sx={{ width: 200, height: "90px", fontSize: "1rem" }}
                startIcon={<CategoryIcon />}
                onClick={() => handleNavigate("expense")}
              >
                EXPENSE
              </MDButton>
            </Grid>
            <Grid item xs={12} sm={2} mx={1} mt={2} py={1} px={2}>
              <MDButton
                fullWidth
                color="info"
                variant="gradient"
                size="large"
                sx={{ width: 200, height: "90px", fontSize: "1rem" }}
                startIcon={<CategoryIcon />}
                onClick={() => handleNavigate("advance")}
              >
                ADVANCE
              </MDButton>
            </Grid>
            <Grid item xs={12} sm={2} mx={1} mt={2} py={1} px={2}>
              <MDButton
                fullWidth
                color="info"
                variant="gradient"
                size="large"
                sx={{ width: 200, height: "90px", fontSize: "1rem" }}
                startIcon={<CategoryIcon />}
                onClick={() => handleNavigate("settlement")}
              >
                ADVANCE SETTLEMENT
              </MDButton>
            </Grid>
            <Grid item xs={12} sm={3} mx={1} mt={2} py={1} px={2}>
              <MDButton
                fullWidth
                color="info"
                variant="gradient"
                size="large"
                sx={{
                  width: 240,
                  height: "90px",
                  fontSize: "0.9rem",
                  whiteSpace: "normal",
                  lineHeight: 1.2,
                }}
                startIcon={<CategoryIcon />}
                onClick={() => handleNavigate("alltypesfeesreport")}
              >
                ALL TYPES OF FEES REPORT
              </MDButton>
            </Grid>
          </Grid>
        );
    }
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={6} pb={3}>
        {loading ? (
          <MDBox display="flex" justifyContent="center" alignItems="center" minHeight="50vh">
            <CircularProgress color="info" />
          </MDBox>
        ) : (
          <Card>
            <MDBox
              mx={2}
              mt={-1}
              py={1}
              px={2}
              bgColor="info"
              borderRadius="lg"
              coloredShadow="info"
              display="flex"
              justifyContent="space-between"
              alignItems="center"
            >
              <MDTypography variant="h6" color="white">
                ADVANCES & EXPENSES
              </MDTypography>
              {activeView !== "home" && (
                <MDButton
                  variant="contained"
                  coloredShadow="info"
                  onClick={handleBack}
                  startIcon={<Icon>arrow_back</Icon>}
                  sx={{ mb: 0 }}
                >
                  Back to Advances & Expenses
                </MDButton>
              )}
            </MDBox>
            <MDBox p={1}>{renderContent()}</MDBox>
          </Card>
        )}
      </MDBox>
      <MDBox display="flex" flexDirection="column" minHeight="50vh">
        {/* This empty div is intentional for layout spacing */}
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default AdvExp;
